import { render, staticRenderFns } from "./census-remark.vue?vue&type=template&id=030ba479"
import script from "./census-remark.vue?vue&type=script&lang=ts"
export * from "./census-remark.vue?vue&type=script&lang=ts"
import style0 from "./census-remark.vue?vue&type=style&index=0&id=030ba479&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports